var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "29px",
    viewBox: "0 0 26 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_kosz") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_kosz",
    strokeWidth: 0,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.94,28 L8.09,28 C6.34478019,28 4.93,26.5852198 4.93,24.84 L2.93,4.61 L22.03,4.61 L20.03,24.9 C20.0085652,26.5992439 18.6391658,27.973075 16.94,28 Z M4.36,5.87 L6.19,24.78 C6.16831262,25.2994761 6.35822949,25.8055385 6.71633005,26.1824865 C7.0744306,26.5594344 7.57009508,26.7750366 8.09,26.78 L16.94,26.78 C17.9854337,26.7744976 18.8300145,25.9254482 18.83,24.88 L20.67,5.88 L4.36,5.87 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5,5.56 L6.5,5.56 L6.5,3.34 C6.5,1.77151131 7.77151131,0.5 9.34,0.5 L15.66,0.5 C17.2301145,0.499990335 18.5044908,1.76989512 18.51,3.34 L18.5,5.56 Z M7.12,4.93 L17.87,4.93 L17.87,3.34 C17.8644947,2.1178349 16.8721775,1.1299876 15.65,1.13 L9.33,1.13 C8.1094507,1.13 7.12,2.1194507 7.12,3.34 L7.12,4.93 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.13,4.61 L23.89,4.61 C24.2379394,4.61 24.52,4.89206061 24.52,5.24 C24.52,5.58793939 24.2379394,5.87 23.89,5.87 L1.13,5.87 C0.782060608,5.87 0.5,5.58793939 0.5,5.24 C0.5,4.89206061 0.782060608,4.61 1.13,4.61 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.72,9 C9.06955087,9.0054624 9.35004268,9.29040646 9.35,9.64 L9.98,22.91 C9.98,23.2579394 9.69793939,23.54 9.35,23.54 C9.00206061,23.54 8.72,23.2579394 8.72,22.91 L8.09,9.64 C8.08995732,9.29040646 8.37044913,9.0054624 8.72,9 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,9 C12.8495509,9.0054624 13.1300427,9.29040646 13.13,9.64 L13.13,22.91 C13.13,23.2579394 12.8479394,23.54 12.5,23.54 C12.1520606,23.54 11.87,23.2579394 11.87,22.91 L11.87,9.64 C11.8699573,9.29040646 12.1504491,9.0054624 12.5,9 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3,9 C16.4697386,9 16.6325251,9.06742838 16.7525483,9.18745166 C16.8725716,9.30747494 16.94,9.47026145 16.94,9.64 L16.3,22.91 C16.3,23.2579394 16.0179394,23.54 15.67,23.54 C15.3220606,23.54 15.04,23.2579394 15.04,22.91 L15.67,9.64 C15.6699573,9.29040646 15.9504491,9.0054624 16.3,9 L16.3,9 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTrash);
export default __webpack_public_path__ + "static/media/ic_trash.8f7d8728a7d44a30d13415b1a72afea6.svg";
export { ForwardRef as ReactComponent };